<template>
    <div class="wrapper copyright_wrapper">
        <div class="wrap copyright_wrap">
            <div class="l_logo">
                <img src="../assets/image/coms/footer_logo.png" alt="logo" class="logo_img">
                <div class="links">
                    <ul>
                        <li class="title">关于我们</li>
                        <li>
                            <a href="https://yixing-media.com/media/home" target="_blank">公司介绍</a>
                        </li>
                        <li>
                            <a  @click="clk_expo">招商入驻</a>
                        </li>
                    </ul>
                    <ul>
                        <li class="title">友情外链</li>
                        <li>
                            <a href="https://www.jiancaizj.com/" target="_blank">建材之家</a>
                        </li>
                        <li>
                            <a href="https://www.jszhaobiao.com/" target="_blank">中国建设招标网</a>
                        </li>
                    </ul>
                    <ul>
                        <li class="title">联系我们</li>
                        <li>
                            <a>官方客服：400-8081-705</a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="qrcodes">
                <div class="qrcode_item">
                    <img src="../assets/image/news/xcx_qr.jpg" alt="小程序">
                    <p>微信小程序</p>
                </div>
                <div class="qrcode_item">
                    <img src="../assets/image/coms/service_qr.png" alt="公众号">
                    <p>微信公众号</p>
                </div>
                <div class="qrcode_item">
                    <img src="../assets/image/coms/douyin_qr.png" alt="抖音">
                    <p>抖音</p>
                </div>

            </div>
        </div>
        <div class="wrap hr"></div>
    </div>
</template>

<script>
    export default {
        name: "copyright",
        methods:{
            clk_expo() {
                this.$router.push('/expo')
            }
        }
    }
</script>

<style scoped lang="less">
    /*底部*/
    .copyright_wrapper{
        background-color: rgb(26,35,64);
        /*max-height: 400px;*/
        min-height: 240px;
        padding-top: 60px;
        padding-bottom: 60px;
        box-sizing: border-box;
        color: rgb(235, 236, 237);
    }
    .copyright_wrap{
        display: flex;
        justify-content: space-between;
    }
    .l_logo{
        flex: 1;
        padding-right: 20px;
        box-sizing: border-box;
        display: flex;
    }
    .logo_img {
        max-width: 340px;
        height: auto;
    }

    .links {
        ul {
            float: left;
            margin-left: 25px;

            li {
                line-height: 36px;
            }

            .title {
                color: #fff;
                font-weight: bold;
            }

            a {
                user-select: none;
                text-underline: none;
                color: rgb(152, 158, 206);
            }
        }
    }

    .qrcodes {
        width: 30%;
        display: flex;
        justify-content: space-between;
        .qrcode_item {
            width: 30%;
            text-align: center;

            img {
                width: 100%;
                height: auto;
                padding: 8px;
                background-color: #fff;
                box-sizing: border-box;
            }
        }
    }

    .hr{
        width: 100%;
        border-bottom: solid 1px rgb(52, 61, 81);
        margin-top: 60px;
    }
</style>
